import React, { useEffect } from 'react';

const AutoAppLauncher = () => {
  useEffect(() => {
    // 중복 실행 방지
    if (window.toyotaAppLaunched) return;
    window.toyotaAppLaunched = true;

    // 현재 URL에서 /app 이후 경로 추출
    // e.g. /app/service/center/list.do?foo=bar → service/center/list.do?foo=bar
    const getAppPath = () => {
      const path = window.location.pathname.replace(/^\/app\/?/, '');
      const search = window.location.search;
      return path + search;
    };

    const launchApp = () => {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /android/i.test(navigator.userAgent);

      if (isIOS) {
        launchIOSApp();
      } else if (isAndroid) {
        launchAndroidApp();
      } else {
        // 데스크톱은 앱스토어로
        window.location.href = 'https://itunes.apple.com/kr/app/Yo!%20Toyota!/id1456577899?mt=8';
      }
    };

    const launchIOSApp = () => {
      const scheme = 'yotoyota://' + getAppPath();
      const storeUrl = 'https://itunes.apple.com/kr/app/Yo!%20Toyota!/id1456577899?mt=8';

      let isAppLaunched = false;
      let fallbackTimer = null;

      // 페이지 숨김 감지 (앱 실행시 페이지가 숨겨짐)
      const handleVisibilityChange = () => {
        if (document.hidden && !isAppLaunched) {
          isAppLaunched = true;
          if (fallbackTimer) {
            clearTimeout(fallbackTimer);
            fallbackTimer = null;
          }
          // 앱이 실행됨 - 스토어로 가지 않음
          console.log('앱이 실행되었습니다');
        }
      };

      // 포커스 복귀 감지 (앱에서 브라우저로 돌아올 때)
      const handleFocus = () => {
        if (fallbackTimer && !isAppLaunched) {
          // 앱이 실행되었다가 돌아온 경우
          isAppLaunched = true;
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
          console.log('앱에서 돌아왔습니다');
        }
      };

      // 이벤트 리스너 등록
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('focus', handleFocus);

      // 앱 스킴 실행
      window.location.href = scheme;

      // 2초 후에도 앱이 실행되지 않으면 앱스토어로 이동
      fallbackTimer = setTimeout(() => {
        if (!isAppLaunched && !document.hidden) {
          console.log('앱이 설치되지 않음 - 앱스토어로 이동');
          window.location.href = storeUrl;
        }
      }, 1000);

      // 클린업 함수
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('focus', handleFocus);
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
        }
      };
    };

    const launchAndroidApp = () => {
      const appPath = getAppPath();
      // const schemes = [
      //   'yotoyota://' + appPath,
      //   'com.yo.toyota://' + appPath,
      //   'toyota://' + appPath
      // ];
      const marketUrl = 'market://details?id=com.yo.toyota';
      const webStoreUrl = 'https://play.google.com/store/apps/details?id=com.yo.toyota';

      let isAppLaunched = false;
      let fallbackTimer = null;

      // 페이지 숨김/포커스 감지
      const handleVisibilityChange = () => {
        if (document.hidden && !isAppLaunched) {
          isAppLaunched = true;
          if (fallbackTimer) {
            clearTimeout(fallbackTimer);
            fallbackTimer = null;
          }
        }
      };

      const handleFocus = () => {
        if (fallbackTimer && !isAppLaunched) {
          isAppLaunched = true;
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('focus', handleFocus);

      // 첫 번째 스킴 시도
      const intentUrl =
          'intent://' + appPath +
          '#Intent;scheme=yotoyota;' +
          'package=com.yo.toyota;' +
          'S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.yo.toyota;' +
          'end;';


      window.location.href = intentUrl;

      // 2.5초 후 앱이 실행되지 않으면 스토어로
      // fallbackTimer = setTimeout(() => {
      //   if (!isAppLaunched && !document.hidden) {
      //     try {
      //       window.location.href = marketUrl;
      //     } catch (e) {
      //       window.location.href = webStoreUrl;
      //     }
      //   }
      // }, 1000);

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('focus', handleFocus);
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
        }
      };
    };

    // 100ms 후 실행 (컴포넌트 마운트 완료 후)
    const timer = setTimeout(() => {
      launchApp();
    }, 100);

    // 클린업
    return () => {
      clearTimeout(timer);
    };
  }, []);

  // UI 없음 - 빈 div만 렌더링
  return <div style={{ display: 'none' }} />;
};

export default AutoAppLauncher;

